import Vue from 'vue';
// Make it available globally.
Vue.directive('readonly-roles', function (el, binding) {
    let user = binding.value.user;
    let roles = binding.value.roles;
    let show = false;
    if (user.roles.length > 0) {
        user.roles.forEach(role => {
            if (roles.includes(role.name))
                show = true;
        });
        if (!show)
            el.readOnly = true;
    }
});